// extracted by mini-css-extract-plugin
module.exports = {"articles":"blog_articles__6gFeg","article":"blog_article__oiywq","postHeader":"blog_postHeader__DhtBZ","commentsBlock":"blog_commentsBlock__OPJid"};